import waterEngineApi from '@/api/config/waterEngineApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { getApiErrorMessage, getApiErrorStatus } from '@/helpers/notify'

function useGetDetailWaterEngine(interfaceId: number, options = {}) {
  return useQuery({
    queryKey: [queryKeys.getWaterEngine, interfaceId],
    queryFn: async () => {
      if (!interfaceId) return null

      const { data } = await waterEngineApi.getDetail(interfaceId)

      if (!data) return null
      return data
    },
    onError: (error: unknown) => {
      // A controller with no water engine yet (e.g. just reset) answers 404:
      // nothing to report. `data.Message` was read before, which is never
      // set, so every failure raised an empty red toast.
      if (getApiErrorStatus(error) === 404) return
      toast.error(getApiErrorMessage(error), { id: 'water-engine-error' })
    },
    ...options,
  })
}

export default useGetDetailWaterEngine
